// Libraries
var React = require("react");

// Components
var Icon = require('../../common/Icon/Icon.js');

// Style
require("./Pagination.scss");

class PaginationModule extends React.Component {
  constructor(props) {

    super(props);

  }

  handleClick(index) {

    const page = index + 1;
    this.props.parentCallback(page);

  }

  render() {
    if (this.props.data.pages < 2) { return null; }
    return (
      <nav id={this.props.data.id} className={`c-pagination${this.props.data.isPremium ? " c-pagination--premium" : ""}${(this.props.data.pages > 3) ? " c-pagination--busy" : ""}`} aria-label="Pagination Navigation">
        {(this.props.data.page > 1) &&
          <p className="c-pagination__prev">
            <button type="button" className="c-pagination__prev__button" onClick={this.handleClick.bind(this, (this.props.data.page - 2))}>
              <Icon name="arrowLeft" width={16.531} height={13.838} />
              <span className="u-visually-hidden">Navigate to page {this.props.data.page - 1}</span>
            </button>
          </p>
        }
        <ul className="c-pagination__list">
          {[...Array(this.props.data.pages)].map((x, index) =>
            <li className={`c-pagination__item${((index + 1) === this.props.data.page) ? " c-pagination__item--active" : ""}`} key={index}>
              {((index + 1) === this.props.data.page) ? (
                <span className="c-pagination__active">
                  <span className="u-visually-hidden">Viewing page </span><span aria-current="true">{index + 1}</span>
                </span>
              ) : (
                <button type="button" onClick={this.handleClick.bind(this, index)} className="c-pagination__button">
                  <span className="u-visually-hidden">Navigate to page </span>{index + 1}
                </button>
              )}
            </li>
          )}
        </ul>
        {(this.props.data.page < this.props.data.pages) &&
          <p className="c-pagination__next">
            <button type="button" className="c-pagination__next__button" onClick={this.handleClick.bind(this, this.props.data.page)}>
              <Icon name="arrowLeft" width={16.531} height={13.838} />
              <span className="u-visually-hidden">Navigate to page {this.props.data.page + 1}</span>
            </button>
          </p>
        }
      </nav>
    );
  }
}

module.exports = PaginationModule;



// WEBPACK FOOTER //
// ./src/components/Pagination/Pagination.js